import {Meta, Title} from '@angular/platform-browser';
import {Component} from '@angular/core';
import {services} from "../../services";

@Component({

  selector: 'overwatch-divisions',
  templateUrl: './overwatch-divisions.component.html'
})
export class OverwatchDivisionsComponent {
  public service = 'divisions';
  public availableServices = services['overwatch'].filter(service => service.service !== this.service);

  constructor(meta: Meta, title: Title) {
    title.setTitle('Overwatch 2 Boosting - Rank Boosting for Overwatch 2');
    meta.updateTag(
      // tslint:disable-next-line:max-line-length
      {
        name: 'description',
        content: 'Ascend in Overwatch ranks with GGBoost. Choose the Best and Safest boosting services, ensuring Top-Tier Performance in every battle'
      }
    );
  }
}
